<template>
  <transition name="dialog-fade">
    <div v-if="isVisible" class="onvif-dialog-overlay">
      <div class="onvif-dialog-container">
        <div class="onvif-dialog-content">
          <h4 class="onvif-dialog-title">ONVIF操作 継続確認</h4>
          
          <div class="onvif-dialog-text">
            <p>操作画面から再生画面に戻ります。よろしいですか？</p>
            <p class="onvif-dialog-note">
              ［No］を選択して操作画面を継続すると、通信量が増加します。選択しない場合 、1 分後に自動で再生画面に戻ります。
            </p>
          </div>

          <div class="onvif-dialog-actions">
            <button 
              class="onvif-btn onvif-btn-yes" 
              @click="handleYes"
            >
              Yes
            </button>
            <button 
              class="onvif-btn onvif-btn-no" 
              @click="handleNo"
            >
              No
            </button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'OnvifConfirmationDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isVisible: this.visible
    };
  },
  watch: {
    visible(newVal) {
      this.isVisible = newVal;
    }
  },
  methods: {
    handleYes() {
      this.$emit('accept');
      this.close();
    },
    handleNo() {
      this.$emit('cancel');
      this.close();
    },
    close() {
      this.isVisible = false;
      this.$emit('update:visible', false);
      this.$emit('close');
    }
  }
};
</script>

<style lang="scss" scoped>
.onvif-dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 99999;
}

.onvif-dialog-container {
  background: white;
  border-radius: 16px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
  max-width: 425px;
  width: 90%;
  padding: 20px;
  animation: dialog-slide-up 0.3s ease-out;
}

.onvif-dialog-title {
  color: #C84C47;
  font-size: 20px;
  font-weight: 700;
  margin: 0 0 20px 0;
  text-align: left;
}

.onvif-dialog-text {
  color: #333;
  font-size: 16px;
  line-height: 1.8;
  margin-bottom: 16px;
  text-align: left;

  p {
    margin: 0 0 16px 0;
  }

  .onvif-dialog-note {
    color: black;
    font-size: 13px;
    line-height: 1.6;
    margin: 0 0 24px 0;
  }
}

.onvif-dialog-actions {
  display: flex;
  gap: 16px;
  justify-content: flex-end;
}

.onvif-btn {
  padding: 14px 32px;
  font-size: 16px;
  font-weight: 600;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 120px;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }

  &:active {
    transform: translateY(0);
  }
}

.onvif-btn-yes {
  background-color: #C84C47;
  color: white;

  &:hover {
    background-color: #B23E3A;
  }
}

.onvif-btn-no {
  background-color: white;
  color: #666;

  &:hover {
    background-color: #D0D0D0;
  }
}

.dialog-fade-enter-active,
.dialog-fade-leave-active {
  transition: opacity 0.3s ease;
}

.dialog-fade-enter,
.dialog-fade-leave-to {
  opacity: 0;
}

@keyframes dialog-slide-up {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>